import { render, staticRenderFns } from "./SnapDashboard.vue?vue&type=template&id=8fec1f32"
import script from "./SnapDashboard.vue?vue&type=script&lang=js"
export * from "./SnapDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports